// Map location search Jquery plugin
define('commons/map-location-search',[ 'jquery', 'commons/autocomplete', 'async!google-maps' ], function($, Autocomplete) {

    var methods = {
        init : function(options) {
            this.settings = $.extend({}, {
                inputNode : null,
                gmapNode : null,
                zoom : 11,
                lat : 0,
                lng : 0,
                title : "",
                icon : null
            }, options);

            this.settings.inputNode = (this.settings.inputNode === null ? this.find("input.locationSearchInput").get(0) : $(this.settings.inputNode)
                    .get(0));
            this.settings.gmapNode = (this.settings.gmapNode === null ? this.find("div.locationSearchMap").get(0) : $(this.settings.gmapNode).get(0));

            // Map
            var startPos = new google.maps.LatLng(this.settings.lat, this.settings.lng);
            this.map = new google.maps.Map(this.settings.gmapNode, {
                'disableDoubleClickZoom' : true,
                'center' : startPos,
                'zoom' : this.settings.zoom,
                'mapTypeId' : google.maps.MapTypeId.ROADMAP,
                'streetViewControl' : false,
                rotateControl : false
            });
            this.map.setTilt(0);

            // Autocomplete
            var autocomplete = new Autocomplete("input.locationSearchInput", this.map);

            // Marker
            this.marker = new google.maps.Marker({
                map : this.map,
                position : startPos,
                icon : this.settings.icon,
                animation : google.maps.Animation.DROP,
                title : this.settings.title,
                draggable : true
            });

            var onPositionChange = function(event) {
                this.marker.setPosition(event.latLng);
                this.trigger("onPositionChange", event.latLng);
            };

            // Place the marker by double clicking on the map
            google.maps.event.addListener(this.map, 'dblclick', $.proxy(onPositionChange, this));

            // Place the marker by dragging it
            google.maps.event.addListener(this.marker, 'dragend', $.proxy(onPositionChange, this));

            return this;
        },

        changePosition : function(lat, lng) {
            var pos = new google.maps.LatLng(lat, lng);
            this.marker.setPosition(pos);
            this.map.setCenter(pos);
        },

        center : function() {
            this.map.setCenter(this.marker.getPosition());
        },

        reset : function() {
            this.settings.inputNode.blur();
            this.settings.inputNode.value = "";
            methods.center.call(this);
            this.map.setZoom(this.settings.zoom);
        }
    };

    $.fn.mapLocationSearch = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.tooltip');
        }
        return this;
    };
});
